import type {
  ReactNode,
} from 'react'

import type {
  MeResponse,
} from '../../types/me'

type AdminGuardProps = {
  status: string
  me: MeResponse | null
  children: ReactNode
}

function HiddenNotFound() {
  return (
    <div className="admin-not-found">
      <div className="admin-not-found__content">
        <div className="admin-not-found__code">
          404
        </div>

        <h1>
          Страница не найдена
        </h1>

        <p>
          Возможно, страница была удалена,
          перемещена или никогда не существовала.
        </p>

        <a href="/">
          На главную
        </a>
      </div>
    </div>
  )
}

export function AdminGuard({
  status,
  me,
  children,
}: AdminGuardProps) {
  if (
    status === 'loading' ||
    status === 'idle'
  ) {
    return null
  }

  if (
    status !== 'authenticated' ||
    !me ||
    me.role !== 'admin'
  ) {
    return <HiddenNotFound />
  }

  return children
}
